import React, { useCallback } from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { SiteFooter } from '../components/SiteFooter';
export function Home() {
  const scrollToSubscribe = useCallback(() => {
    document.getElementById('subscribe')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, []);
  return <div className="min-h-screen w-full bg-wt-background-color font-['Montserrat',ui-sans-serif,system-ui,sans-serif] text-neutral-900" data-id="element-37" data-mp="2x7sl6t8vlhtm">
      <SiteHeader onSubscribeClick={scrollToSubscribe} data-id="element-38" data-mp="24gio2lu7dqs1" />
      <main data-id="element-39" data-mp="24j4u2h1g3y85">
        <Hero data-id="element-40" data-mp="29g4yknincsx5" />
      </main>
      <SiteFooter data-id="element-41" data-mp="29fvj3tv8a45p" />
    </div>;
}